module.exports = __webpack_public_path__ + "fonts/Roboto-Medium.f9f0c87.eot";